import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials makes the browser send the httpOnly `tf_auth` cookie with every
// request. Auth tokens are never touched by JS — this closes the XSS attack surface
// that the older localStorage-based scheme had.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");
export const dollars = (cents) => `$${(cents / 100).toFixed(2)}`;
